import { logToErrbit } from '../../components/helpers/error_boundary';
import api from '../../mdms_api';

export default async publicationId => {
  const response = await api.get(`/api/v1/dms/meta/${publicationId}`);
  if (response.ok) return response.json();
  if (response.status === 404) {
    logToErrbit(
      new Error(`Authored content references DMS document ${publicationId}, which DMS no longer has`),
      'DMS Document'
    );
    return null;
  }

  throw new Error(`DMS document lookup failed: HTTP ${response.status}`);
};
